<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-form>
      <v-card flat>
        <v-layout row wrap>
          <v-card color="grey lighten-5" flat>
            <v-flex xs12 sm12>
              <v-toolbar size="120px" dark color="info">
                <v-toolbar-title class="baslikfont">{{ $t('Current-Account-General-Parameters') }} </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn hidden="xs" flat @click="Kaydet()"> {{$t("save_button")}}
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
              </v-toolbar>

            </v-flex>
            <v-container fluid>
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm4 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>


                        <v-layout row="" wrap="">
                          <v-flex pa-1 xs12 sm12 md12>
                            <v-text-field :label="$t('VAT-Rate')" hide-details="" v-model="GenelParametre.KdvOran">
                            </v-text-field>
                            <v-text-field :label="$t('Arkman-Transfer-Group')" hide-details=""
                              v-model="GenelParametre.AktarimSure"></v-text-field>

                          </v-flex>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm4 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout row="" wrap="">
                          <v-flex pa-1 xs12 sm12 md12>


                            <v-menu :close-on-content-click="true" v-model="menu" transition="scale-transition" offset-y
                              full-width :nudge-right="40" min-width="290px">
                              <v-text-field hide-details="" slot="activator" :label="$t('Date-of-Closing-Invoice')"
                                v-model="dateFormatted" append-icon="event" v-on:change="onChange" mask="##.##.####"
                                @blur="date = parseDate(dateFormatted)"></v-text-field>
                              <v-date-picker locale="tr" v-model="date" @input="dateFormatted = formatDate($event)"
                                no-title scrollable actions>
                                <v-spacer></v-spacer>
                              </v-date-picker>
                            </v-menu>


                            <v-text-field :label="$t('Number-of-Last-Receipt')" hide-details=""
                              v-model="GenelParametre.SonDekontNo"></v-text-field>


                          </v-flex>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm4 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout row="" wrap="">
                          <v-flex pa-1 xs12 sm12 md12>
                            <v-text-field :label="$t('Airline-Account-Group')" hide-details=""
                              v-model="GenelParametre.HavaYoluHesapGrubu"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Take-Receipt-to-Current-as-Single-Entry')" hide-details="" v-model="GenelParametre.DekontTek"
                    value="1"></v-switch>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Open-Current-Cards-to-All-Companies')" hide-details=""
                    v-model="GenelParametre.TumSirketler" value="1"></v-switch>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Make-All-Companies-Selected')" hide-details="" v-model="GenelParametre.TumSirketSecili"
                    value="1"></v-switch>
                </v-flex>



                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Do-Not-Show-Main-Screen')" hide-details="" v-model="GenelParametre.AnaEkran" value="1" c>
                  </v-switch>
                </v-flex>


                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Expense-Center-Obligatory')" hide-details="" v-model="GenelParametre.MasrafZorunlu"
                    value="1"></v-switch>
                </v-flex>



                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Data-Export-Special-Code-Obligatory')" hide-details=""
                    v-model="GenelParametre.DisAkatarimZorunlu" value="1"></v-switch>
                </v-flex>



                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Activate-Starting-Date-of-Invoice-Closing')" hide-details=""
                    v-model="GenelParametre.FaturaKapamaAktif" value="1"></v-switch>
                </v-flex>
                    <v-flex xs12 sm6 md4>
                  <v-switch label="Next Muhasebe" hide-details=""
                    v-model="GenelParametre.NextMuhasebe" 
    ></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-layout>
      </v-card>
    </v-form>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}

          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import helpers from "@/components/app/customcomp/helpers.js"

  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        date: null,
        dateFormatted: null,
        menu: false,
        drawer: null,
        baslik: '',
        GenelParametre: {
          KdvOran: '',
          HavaYoluHesapGrubu: '',
          SerbestFatura: '',
          SonDekontNo: '',
          DekontTek: '',
          TumSirketler: '',
          XmlPath: '',
          AktarimSure: '',
          XmlPathCari: '',
          XmlPathMaliyetFaturasi: '',
          XmlPathCariHareket: '',
          TumSirketSecili: '',
          FaturaEn: '',
          FaturaBoy: '',
          OzelBoy: '',
          Dot9Sifre: '',
          BolgeAyar: '',
          AnaEkran: '',
          CariAra: '',
          MasrafZorunlu: '',
          MerkezKur: '',
          SerbestFaturaDoviz: '',
          FaturaKapamaAktif: '',
          NextMuhasebe: false,
          FaturaKapamaTarih: '',
          CariAramaIc: '',
          DisAkatarimZorunlu: ''
        },
        text1: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog
    },
    mounted() {

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {


        var params = {}
        this.$http.post(auth.API_URL + 'api/Parameters/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.GenelParametre = response.body
          
          var bastarih = response.body.FaturaKapamaTarih.split("T")
          if (String(bastarih[0]) === '0001-01-01') {
            response.body.FaturaKapamaTarih = null
          } else {
            this.GenelParametre.FaturaKapamaTarih = response.body.FaturaKapamaTarih
            var partsvalue = response.body.FaturaKapamaTarih.split("T")
            this.date = partsvalue[0]
            this.dateFormatted = toDateformat(this.date)
          }

        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true

          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true

          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },

    methods: {
      formatDate(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {

        } else if (n == -1 && m != 8) {
          this.dateFormatted = getDateNow()
          this.date = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      onChange: onChange,
      getDateNow: getDateNow,
      toDateformat: toDateformat,
      Kaydet: Kaydet
    },

  }

  function Kaydet() {
    this.GenelParametre.FaturaKapamaTarih = this.date
    var params = this.GenelParametre
    this.$http.post(auth.API_URL + 'api/Parameters/Add', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      }
    })
  }



  function beforeMount() {

  }

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      this.date = b
    } else {
      this.dateFormatted = null
    }
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '-' + mm + '-' + yyyy
    return today
  }
</script>
<style>
</style>